export const treeItem = {
  li: {
    '.MuiTreeItem-content': {
      borderRadius: 0,
      minHeight: 34,
      padding: '7px 12px',
      '&:hover': {
        backgroundColor: 'rgba(44, 123, 116, 0.08)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(28, 45, 64, 0.06)',
        '&:hover': {
          backgroundColor: 'rgba(28, 45, 64, 0.08)',
        },
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(28, 45, 64, 0.06)',
      },
    },
    '.Mui-selected': {
      '.MuiTreeItem-label': {
        span: { fontWeight: 500 },
      },
    },
  },
} as const;

export const treeItemStyles = {
  marginLeft: 0,
  '.MuiTreeItem-iconContainer': {
    width: '0px !important',
  },
};
